import { render, staticRenderFns } from "./ckEditorUIComponent.vue?vue&type=template&id=c7337d28&scoped=true"
import script from "./ckEditorUIComponent.vue?vue&type=script&lang=js"
export * from "./ckEditorUIComponent.vue?vue&type=script&lang=js"
import style0 from "./ckEditorUIComponent.vue?vue&type=style&index=0&id=c7337d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7337d28",
  null
  
)

export default component.exports